/**
 * @param 彩之云appSDK
 * 
*/

function loadURL(url) {
  var iFrame;
  iFrame = document.createElement("iframe");
  iFrame.setAttribute("src", url); iFrame.setAttribute("style", "display:none;");
  iFrame.setAttribute("height", "0px"); iFrame.setAttribute("width", "0px");
  iFrame.setAttribute("frameborder", "0"); document.body.appendChild(iFrame);
  // 发起请求后这个iFrame就没用了，所以把它从dom上移除掉
  iFrame.parentNode.removeChild(iFrame); iFrame = null;
}
/**
 * 注意:(对于ios)
 * 付成功返回界面的时候，如果有先提示一个404报错，然后跳转到回调的地址页面，请使用下面的方法 
 * **/ 
function ios(sn,url) {
  loadURL("*payFromHtml5*"+sn+"*"+url);
}

/***
 * JS 调用 Android 代码
 * 格式:jsObject.payFromHtml(彩之云订单号，回调状态地址);
 * jsObject.payFromHtml此方法是固定的方法名,安卓会自动识别 * @paramsn彩之云订单号
 * @param 回调地址
*/
function android(sn,url) {
  window.jsObject.payFromHtml(sn,url)
}

/**
 * @return JS实例方法 调用IOS代码
 * 格式:*payFromHtml5*彩之云订单号*回调状态地址
 * payFromHtml5,ios会自动识别
 * @param  彩之云订单号 
 * @param 回调地址
 * 如: 彩之云单号为:2030002150421134304090，
 *     回调地址(支付成功或失败后会调用商家传过来的地址用来显示给用户)
*/
function getPayfulLife(payStrCode, return_url) {
  if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
    ios(payStrCode, return_url); //苹果调用代码
  }else{
    android(payStrCode, return_url); //android
  }
}

export {
  getPayfulLife
}